<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loading.page">
    <a-config-provider :locale="getLocalConfigProvider()">
      <div class="wrapper">
        <div class="wrapper-header">
          <span>
            <a-icon type="wallet" class="margin-right-small" />
            {{ $route.meta.title }}
          </span>
          <a-button @click="handleReload" size="small" icon="reload"></a-button>
        </div>
        <div class="wrapper-body">
          <a-card>
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
                <a-input-search v-model="search" @change="moresearch" placeholder="Quick Search" :loading="loading.search"/>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
                <div style="width:100%;text-align:left">
                  <a-badge :dot="showbadge">
                    <a-button
                      :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                      @click="handleshowMore"
                      class="m-width-full"
                      :class="getScreen ? 'margin-top m-width-full' : 'm-width-full'"
                      >{{
                        advancedsearch == "display:none" ? "More" : "Less"
                      }}</a-button
                    >
                  </a-badge>
                </div>
              </a-col>
            </a-row>
            <a-row :style="advancedsearch" :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 6 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Year</label>
                  <a-date-picker
                    placeholder="Select Year"
                    v-model="transyear"
                    :open="yearPickShow"
                    @panelChange="handlePanelChange"
                    @change="moresearch"
                    @openChange="handleOpenChange"
                    format="YYYY"
                    mode="year"
                    allowClear
                  />
                </div>
              </a-col>
            </a-row>
          </a-card>
          <div class="bordered">
            <a-table
              :rowKey="(record, index) => {
                return index.toString();
              }
                "
              size="small"
              bordered
              :scroll="{ x: 600 }"
              :columns="columnSelected"
              :dataSource="source_data"
              :loading="loading.tabel"
              :pagination="pagination"
              :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }"
            >
              <template slot="sptmassa" slot-scope="item">
                {{item.spt_masa}}
              </template>
              <template slot="no_spt" slot-scope="item">
                <a @click="toManifest(item.spt_id)">{{ item.no_spt }}</a>
              </template>
              <template slot="ppn_out" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.keluaran"
                />
              </template>
              <template slot="ppn_in" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.masukan"
                />
              </template>
              <template slot="tax_value" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.tax_value"
                />
              </template>
              <template slot="compensation" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.kompensasi"
                />
              </template>
              <template slot="pbk" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.pbk"
                />
              </template>
              <template slot="overpayment" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.overpayment"
                />
              </template>
              <template slot="compensationrealize" slot-scope="item">
                  <a @click="toManifest(item.realisasi_kompensasi_id)">{{ item.realisasi_kompensasi_no }}</a>
                </template>
              <template slot="payment" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.payment"
                />
              </template>
              <template slot="datereport" slot-scope="item">
                {{ item.date_report }}
              </template>
              <template slot="sptrevision" slot-scope="item">
                <a @click="toManifest(item.spt_id_revisi)">{{ item.spt_no_revisi }}</a>
              </template>
              <template slot="salary" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.gaji"
                />
              </template>
              <template slot="commision" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.komisi"
                />
              </template>
              <template slot="saverancepay" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.pesangon"
                />
              </template>
              <template slot="pph22" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.pph_22"
                />
              </template>
              <template slot="pph23" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.pph_23"
                />
              </template>
              <template slot="pphp4" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.pph_pasal4"
                />
              </template>
              <template slot="others" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="'IDR'"
                  :valueNumber="item.lain"
                />
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </a-config-provider>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod";

export default {
  name: "listRecapitulationSPT",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      timer: null,
      loading: {
        search: false,
        page: false,
        tabel:false,
      },
      search: undefined,
      transyear: moment(),
      showbadge: false,
      advancedsearch: "display:none",
      source_data: [],
      source_ori: [],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      yearPickShow: false,
      columns: {
        ppn : [
        {
          title: "SPT Masa",
          key: "sptmassa",
          align: "center",
          scopedSlots: { customRender: "sptmassa" },
          width: 150,
        },
        {
          title: "No. SPT",
          key: "no",
          scopedSlots: { customRender: "no_spt" },
          width: 250,
        },
        {
          title: "PPN Out",
          key: "ppn_out",
          scopedSlots: { customRender: "ppn_out" },
          width: 250,
        },
        {
          title: "PPN In",
          key: "ppn_in",
          scopedSlots: { customRender: "ppn_in" },
          width: 250,
        },
        {
          title: "Tax Value",
          key: "tax_value",
          scopedSlots: { customRender: "tax_value" },
          width: 250,
        },
        {
          title: "Compensation",
          key: "compensation",
          scopedSlots: { customRender: "compensation" },
          width: 250,
        },
        {
          title: "PBK",
          key: "pbk",
          scopedSlots: { customRender: "pbk" },
          width: 250,
        },
        {
          title: "Over Payment",
          key: "overpayment",
          scopedSlots: { customRender: "overpayment" },
          width: 250,
        },
        {
          title: "Compensation Realize",
          key: "compensationrealize",
          scopedSlots: { customRender: "compensationrealize" },
          width: 250,
        },
        {
          title: "Payment",
          key: "payment",
          scopedSlots: { customRender: "payment" },
          width: 250,
        },
        {
          title: "Date Report",
          key: "datereport",
          scopedSlots: { customRender: "datereport" },
          align: "center",
          width: 150,
        },
        {
          title: "SPT Revision",
          key: "sptrevision",
          scopedSlots: { customRender: "sptrevision" },
          width: 250,
        },],
        pph21: [
        {
          title: "SPT Masa",
          key: "sptmassa",
          align: "center",
          scopedSlots: { customRender: "sptmassa" },
          width: 150,
        },
        {
          title: "No. SPT",
          key: "no",
          scopedSlots: { customRender: "no_spt" },
          width: 250,
        },
        {
          title: "Salary",
          key: "salary",
          scopedSlots: { customRender: "salary" },
          width: 250,
        },
        {
          title: "Commision",
          key: "commision",
          scopedSlots: { customRender: "commision" },
          width: 250,
        },
        {
          title: "Severance Pay",
          key: "saverancepay",
          scopedSlots: { customRender: "saverancepay" },
          width: 250,
        },
        {
          title: "Tax Value",
          key: "taxvalue",
          scopedSlots: { customRender: "taxvalue" },
          width: 250,
        },
        {
          title: "Compensation",
          key: "compensation",
          scopedSlots: { customRender: "compensation" },
          width: 250,
        },
        {
          title: "PBK",
          key: "pbk",
          scopedSlots: { customRender: "pbk" },
          width: 250,
        },
        {
          title: "OverPayment",
          key: "overpayment",
          scopedSlots: { customRender: "overpayment" },
          width: 250,
        },
        {
          title: "Compensation Realize",
          key: "compensationrealize",
          scopedSlots: { customRender: "compensationrealize" },
          width: 250,
        },
        {
          title: "Payment",
          key: "payment",
          scopedSlots: { customRender: "payment" },
          width: 250,
        },
        {
          title: "Date Report",
          key: "datereport",
          scopedSlots: { customRender: "datereport" },
          align: "center",
          width: 150,
        },
        {
          title: "SPT Revision",
          key: "sptrevision",
          scopedSlots: { customRender: "sptrevision" },
          width: 250,
        },],
        pphunifikasi: [
        {
          title: "SPT Masa",
          key: "sptmassa",
          align: "center",
          scopedSlots: { customRender: "sptmassa" },
          width: 150,
        },
        {
          title: "No. SPT",
          key: "no",
          scopedSlots: { customRender: "no_spt" },
          width: 250,
        },
        {
          title: "PPh 22",
          key: "pph22",
          scopedSlots: { customRender: "pph22" },
          width: 250,
        },
        {
          title: "PPh 23",
          key: "pph23",
          scopedSlots: { customRender: "pph23" },
          width: 250,
        },
        {
          title: "PPh Pasal 4",
          key: "pphp4",
          scopedSlots: { customRender: "pphp4" },
          width: 250,
        }, 
        {
          title: "Others",
          key: "others",
          scopedSlots: { customRender: "others" },
          width: 250,
        },
        {
          title: "Tax Value",
          key: "taxvalue",
          scopedSlots: { customRender: "taxvalue" },
          width: 250,
        },
        {
          title: "Compensation",
          key: "compensation",
          scopedSlots: { customRender: "compensation" },
          width: 250,
        },
        {
          title: "PBK",
          key: "pbk",
          scopedSlots: { customRender: "pbk" },
          width: 250,
        },
        {
          title: "OverPayment",
          key: "overpayment",
          scopedSlots: { customRender: "overpayment" },
          width: 250,
        },
        {
          title: "Compensation Realize",
          key: "compensationrealize",
          scopedSlots: { customRender: "compensationrealize" },
          width: 250,
        },
        {
          title: "Payment",
          key: "payment",
          scopedSlots: { customRender: "payment" },
          width: 250,
        },
        {
          title: "Date Report",
          key: "datereport",
          scopedSlots: { customRender: "datereport" },
          align: "center",
          width: 150,
        },
        {
          title: "SPT Revision",
          key: "sptrevision",
          scopedSlots: { customRender: "sptrevision" },
          width: 250,
        },],
      },
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    rekapType() {
      return this.$route.meta.jns;
    },
    columnSelected() {
      if (this.rekapType == "ppn") {
        return this.columns.ppn
      } else if(this.rekapType == "pph_21"){
        return this.columns.pph21
      } else {
        return this.columns.pphunifikasi
      }
    }
  },
  watch: {
    "rekapType"() {
      this.handleReload();
    },
  },
  methods: {
    moment,
    async handleReload() {
      this.loading.page = true;
      await this.asyncAxiosGet("Rekap_spt", this.getAuth, {
        type: this.rekapType,
        tahun: moment(this.transyear).format("YYYY")
      })
        .then((res) => {
          this.source_data = res.data;
          this.source_ori = res.data;
          this.loading.page = false;
          this.loading.search = false;
          this.loading.tabel = false;
        })
        .catch(() => {
          this.loading.page = false;
          this.loading.search = false;
          this.loading.tabel = false;
        });
    },
    moresearch() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
        this.timer = setTimeout(() => {
          this.loading.search = true;
          this.loading.tabel = true;
          this.source_data = _.filter(this.source_ori, (item) => 
            (item.spt_masa && item.spt_masa.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (item.realisasi_kompensasi_no && item.realisasi_kompensasi_no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (item.spt_no_revisi && item.spt_no_revisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (item.no_spt && item.no_spt.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          )
          this.loading.search = false;
          this.loading.tabel = false;
      }, 600);
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    toManifest(id) {
      this.$router
        .push({
          name: "SPTManifest",
          params: {
            id: id,
            tipe: this.rekapType
          },
        })
    },
    handlePanelChange(value) {
      this.transyear = value;
      this.yearPickShow = false;
      this.handleReload();
    },
    handleOpenChange(status) {
      this.yearPickShow = status;
    },
  },
  mounted() {
    this.handleReload()
  }
}
</script>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead .ant-table-row-cell-break-word {
  text-align: center !important;
}

// .ant-select-dropdown--single{
//   width:500px;
//   overflow: visible!important;
//   display:block!important
// }
// .ant-select-dropdown-menu{
//   width:500px;
//   overflow: visible;
//   display:block;
// }
.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-pertabs {
    height: 30px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
    color: darken(red, 10) !important;
  }
}</style>
